import React from 'react';
import { Controller } from 'react-hook-form';
import {
  MuiPickersUtilsProvider,
  DatePicker as DatePickerBase,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import moment from 'moment';

export function DatePicker({ control, name, controllerProps = {}, ...rest }) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, ref }) => {
        const date = moment(field.value, 'DD/MM/YYYY');

        return (
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBrLocale}>
            <DatePickerBase
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              format="dd/MM/yyyy"
              inputVariant="outlined"
              {...field}
              {...rest}
              ref={ref}
              value={date.isValid() ? date : null}
            />
          </MuiPickersUtilsProvider>
        );
      }}
      {...controllerProps}
    />
  );
}

export default DatePicker;
